module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNzUwMTYgMTMuNDEyOEM4LjU3NTI4IDE0LjQ3MzYgMTAuMTkxIDE0LjQzNSAxMC45NjQ1IDEzLjMzNTlMMTQuOTY0NiA3LjY1MTQzQzE1Ljg5NzEgNi4zMjYzMyAxNC45NDkzIDQuNTAwNDQgMTMuMzI5IDQuNTAwNDRMNC45MDc2NCA0LjUwMDQ0QzMuMjQzMzQgNC41MDA0NCAyLjMwNzE1IDYuNDE0NjEgMy4zMjg5MyA3LjcyODMyTDcuNzUwMTYgMTMuNDEyOFoiIGZpbGw9IiMwRERFRjQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cus_select_icon.svg
// module id = Ro67
// module chunks = 1